export function getOrAdd<TKey, TValue>(map: Map<TKey, TValue>, key: TKey, factoryFunc: (key: TKey) => TValue): TValue {
    if (map.has(key)) {
        return map.get(key) as TValue;
    }
    const newValue = factoryFunc(key);
    map.set(key, newValue);
    return newValue;
}
